import React from "react";
import Home from "@/components/Common/Home";
import Form from './Form';

const OutboundHome = () => <Home form={<Form />} />;

export default OutboundHome;